import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
    suggestions: {
        borderTop: `1px solid ${theme.palette.divider}`,
        flexShrink: 0,
        padding: theme.spacing(1.5, 2),
    },
}));

interface NextActionSuggestionProps {
    disabled: boolean;
    onRequest: () => void;
}

/**
 * Shortcut that asks the assistant for the next best action of the lead.
 */
export const NextActionSuggestion = ({
    disabled,
    onRequest,
}: NextActionSuggestionProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div
            aria-label={t('Assistant.SuggestedActions')}
            className={classes.suggestions}
        >
            <Button
                color="primary"
                disabled={disabled}
                fullWidth
                onClick={onRequest}
                variant="contained"
            >
                {t('Assistant.NextAction')}
            </Button>
        </div>
    );
};
